import Home from "./Home";
import Assistant from "./pages/Assistant";
import Apps from "./pages/Apps";
import Bookmarks from "./pages/Bookmarks";
import GraphQLPlayground from "./pages/GraphQLPlayground";

// Routes that are shown in the main navigation UI
// Each route page index component and it's child components can be found in the pages folder
export const routes = [
  {
    label: "Home",
    path: "/",
    component: Home,
    inNav: true,
  },
  {
    label: "Apps",
    path: "/apps",
    component: Apps,
    inNav: true,
  },
  {
    label: "Bookmarks",
    path: "/bookmarks",
    component: Bookmarks,
    inNav: true,
  },
  {
    label: "Assistant",
    path: "/assistant",
    component: Assistant,
    // Hidden from the nav while the model evaluation is limited to a few testers.
    // The page gates itself as well — this only avoids advertising a dead end.
    inNav: false,
    // Renders without the app navbar so the page reads like the assistant modal.
    chrome: "bare" as const,
  },
  {
    label: "GraphQL",
    path: "/graphql",
    component: GraphQLPlayground,
    inNav: true,
  },
];
